import axios from 'axios';
import { API_BASE_URL } from '../utils/constants';
import useAuthStore from '../store/useAuthStore';

const axiosInstance = axios.create({
  baseURL: API_BASE_URL,
});

// Request Interceptor: Attach Token
axiosInstance.interceptors.request.use(
  (config) => {
    const token = useAuthStore.getState().token;
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Response Interceptor: Handle 401 & Unwrap Data
axiosInstance.interceptors.response.use(
  (response) => {
    // If backend wrapped in ApiResponse<T>, unwrap it and return just the data payload
    if (response.data && response.data.hasOwnProperty('success')) {
      return response.data.data;
    }
    return response.data;
  },
  (error) => {
    if (error.response && error.response.status === 401) {
      // Token expired or invalid
      useAuthStore.getState().logout();
      window.location.href = '/login';
    }
    // Return the error message provided by our backend ApiResponse wrapper if available
    const errorMessage = error.response?.data?.message || 'An unexpected error occurred';
    return Promise.reject(new Error(errorMessage));
  }
);

export default axiosInstance;